const usCoordinates = {
  ne_lat: 73,
  ne_lng: -52,
  sw_lat: 0,
  sw_lng: -177
}

export const CoordinatesFor = {
  UnitedStatesBoundingBox: usCoordinates,
  Colorado: { latitude: 39.742043, longitude: -104.991531 }
}
